import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { GeolocState } from '@tt-lib/components/geolocation/geolocation.component';
import { Coordinate } from 'ol/coordinate';
import { Observable, Subject } from 'rxjs';

export type UpdatedPosition = {
  //only for state GeolocState.OFF, property position can be undefined
  position?: Coordinate;
  geolocState: GeolocState;
};

/**
 * The geolocation component is responsible for starting up the geolocation tracking; 
 * this service is only used to pass the location to other components or services 
 * when tracking is actived by the user
 */
@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

  private updatedPositionSubject: Subject<UpdatedPosition>;
  public updatedPosition$: Observable<UpdatedPosition>;

  private _isActive: WritableSignal<boolean> = signal(false);
  public isActive: Signal<boolean> = this._isActive.asReadonly();

  //an app can update that max zoom level at startup if necessary
  //see setter and getter below (in case of map projection "EPSG:3857", the geolocation component automatically adds 7 to this value)
  //max value is 10 (-1 when not used)
  private _maxAutoZoom: number = -1

  constructor() {
    this.updatedPositionSubject = new Subject<UpdatedPosition>();
    this.updatedPosition$ = this.updatedPositionSubject.asObservable();
  }

  public updatedPosition(newPosition: UpdatedPosition) {
    if (
      newPosition &&
      (
        (this._isActive() && newPosition.geolocState === GeolocState.OFF)
        ||
        (Array.isArray(newPosition.position) && newPosition.position.length === 2 && typeof newPosition.position[0] === "number" && typeof newPosition.position[1] === "number")
      )
    ) {

      const activeStatus = newPosition.geolocState !== GeolocState.OFF;
      if (this._isActive() !== activeStatus) {
        this._isActive.set(activeStatus);
      }

      this.updatedPositionSubject.next(newPosition);
    }
  }


  get maxAutoZoom(): number {
    return this._maxAutoZoom;
  }
  set maxAutoZoom(value: number) {
    if (value >= 0 && value <= 10) {
      this._maxAutoZoom = value;
    } else {
      this._maxAutoZoom = -1
    }
  }
  hasModifiedMaxAutoZoom() {
    return this._maxAutoZoom >= 0;
  }

}
